(() => {
  const HANDLE = 'recordable-pet-talking-buttons-for-dog-communication';
  if (!location.pathname.includes(`/products/${HANDLE}`)) return;

  const GROUPS = [
    ['Preset Buttons', [
      ['Eating No Recording', 'Preset: Meal — No Recording'],
      ['Go Out To Play No Recording', 'Preset: Go Out & Play — No Recording'],
    ]],
    ['Color / Mixed-color Options', [
      ['New Purple', 'Purple'],
      ['New Sunset Afterglow', 'Sunset Afterglow'],
      ['New Yellow And Blue', 'Yellow + Blue'],
    ]],
    ['Recording Colors', [
      ['Recording Macaron Gray', 'Recording: Gray'],
      ['Recording Macaron Green', 'Recording: Green'],
      ['Recording Macaron Pink', 'Recording: Pink'],
      ['Recording Macaron Purple', 'Recording: Purple'],
      ['Recording Macaron Yellow', 'Recording: Yellow'],
      ['Recording Macarons Blue', 'Recording: Blue'],
    ]],
    ['Sets', [['Set1', 'Set 1'], ['Set2', 'Set 2']]],
  ];

  let productData;
  let syncToken = 0;

  const picker = () => document.querySelector(`variant-selects[data-product-handle="${HANDLE}"]`);
  const productInfo = () => picker()?.closest('product-info');
  const fieldsets = (node) => [...node.querySelectorAll('fieldset')];
  const colorField = (node) => fieldsets(node).find((field) => field.querySelector('input[data-option-name="Color"]'));
  const selectedFormId = () => document.querySelector('product-form form[action*="/cart/add"] input[name="id"]')?.value || '';

  function hideNative(node) {
    const color = colorField(node);
    if (color) color.hidden = true;
    fieldsets(node).forEach((field) => {
      const values = [...field.querySelectorAll('input[data-option-name="Specifications"]')];
      if (values.length === 1 && values[0].value === '1PC') field.hidden = true;
    });
  }

  function variantFor(value) {
    return productData?.variants.find((variant) => variant.option1 === value && variant.option2 === '1PC');
  }

  function thumbnailFor(variant) {
    const source = variant?.featured_image?.src || variant?.featured_image || '';
    if (!source) return '';
    return `${source}${source.includes('?') ? '&' : '?'}width=160`;
  }

  function setSyncing(active, message = '') {
    const info = productInfo();
    const ui = document.querySelector(`.pc-vg[data-handle="${HANDLE}"]`);
    if (info) {
      info.classList.toggle('pc-variant-syncing', active);
      info.setAttribute('aria-busy', active ? 'true' : 'false');
    }
    ui?.querySelectorAll('.pc-vg__button').forEach((button) => { button.disabled = active; });
    const status = ui?.querySelector('.pc-vg__status');
    if (status) {
      status.textContent = message;
      status.removeAttribute('role');
    }
  }

  function showError(message) {
    const ui = document.querySelector(`.pc-vg[data-handle="${HANDLE}"]`);
    const status = ui?.querySelector('.pc-vg__status');
    if (status) {
      status.textContent = message;
      status.setAttribute('role', 'alert');
    }
  }

  function syncVisualState() {
    const node = picker();
    const ui = document.querySelector(`.pc-vg[data-handle="${HANDLE}"]`);
    if (!node || !ui) return;
    hideNative(node);
    const checked = colorField(node)?.querySelector('input:checked')?.value || '';
    ui.querySelectorAll('.pc-vg__button').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.value === checked ? 'true' : 'false');
    });
  }

  function mediaMatches(variant) {
    const expected = String(variant?.featured_image?.src || variant?.featured_image || '').split('/').pop()?.split('?')[0];
    if (!expected) return true;
    const active = document.querySelector('[data-pc-gallery-slide].is-active img');
    return Boolean(active?.currentSrc?.includes(expected) || active?.src?.includes(expected));
  }

  function coreVariantStateMatches(variant) {
    const node = picker();
    if (!node || !variant) return false;
    const checked = colorField(node)?.querySelector('input:checked')?.value || '';
    const selectedPrice = node.dataset.selectedPriceAmount || '';
    return selectedFormId() === String(variant.id) && checked === variant.option1 && selectedPrice === (variant.price / 100).toFixed(2);
  }

  function setVariantUrl(variant) {
    const url = new URL(location.href);
    url.searchParams.set('variant', String(variant.id));
    history.replaceState({ ...history.state, variantId: variant.id }, '', url);
  }

  function waitForStableVariant(variant, token) {
    const expectedId = String(variant.id);
    const expectedPrice = (variant.price / 100).toFixed(2);
    const deadline = Date.now() + 20000;
    return new Promise((resolve, reject) => {
      const check = () => {
        if (token !== syncToken) return reject(new Error('Selection superseded'));
        const node = picker();
        const checked = node && colorField(node)?.querySelector('input:checked')?.value;
        const urlId = new URL(location.href).searchParams.get('variant') || '';
        const selectedPrice = node?.dataset.selectedPriceAmount || '';
        if (selectedFormId() === expectedId && urlId === expectedId && checked === variant.option1 && selectedPrice === expectedPrice && mediaMatches(variant)) {
          return setTimeout(resolve, 120);
        }
        if (Date.now() >= deadline) return reject(new Error('Shopify variant state did not stabilize'));
        requestAnimationFrame(check);
      };
      check();
    });
  }

  async function recoverVariantState(previousVariant, token) {
    if (token !== syncToken) return false;

    const formVariant = productData?.variants.find((item) => String(item.id) === selectedFormId());
    if (formVariant && coreVariantStateMatches(formVariant)) {
      setVariantUrl(formVariant);
      syncVisualState();
      return true;
    }

    const node = picker();
    const previousInput = previousVariant && node
      ? [...colorField(node).querySelectorAll('input')].find((item) => item.value === previousVariant.option1)
      : null;
    if (previousVariant && previousInput && !previousInput.disabled) {
      previousInput.click();
      try {
        await waitForStableVariant(previousVariant, token);
        syncVisualState();
        return true;
      } catch (error) {
        // Fall through to a safe page reload using the last known-good variant.
      }
    }

    if (previousVariant) {
      const url = new URL(location.href);
      url.searchParams.set('variant', String(previousVariant.id));
      location.assign(url.toString());
    } else {
      location.reload();
    }
    return false;
  }

  async function selectVariant(value) {
    const node = picker();
    const variant = variantFor(value);
    const input = node && [...colorField(node).querySelectorAll('input')].find((item) => item.value === value);
    if (!node || !variant || !input || input.disabled) return;

    // Clicking the already-selected, fully synchronized option is a no-op.
    // This prevents an unchanged radio input from entering a wait loop that
    // can never receive a Shopify variant-change event.
    if (input.checked && coreVariantStateMatches(variant)) {
      setVariantUrl(variant);
      setSyncing(false, '');
      syncVisualState();
      return;
    }

    const previousVariant = productData?.variants.find((item) => String(item.id) === selectedFormId());
    const token = ++syncToken;
    setSyncing(true, 'Updating selection…');
    input.click();
    try {
      await waitForStableVariant(variant, token);
      setSyncing(false, '');
      syncVisualState();
    } catch (error) {
      if (token !== syncToken) return;
      const recovered = await recoverVariantState(previousVariant, token);
      if (recovered) {
        setSyncing(false, '');
        return;
      }
      showError('Restoring your last confirmed selection…');
    }
  }

  function buildUi(node) {
    let ui = document.querySelector(`.pc-vg[data-handle="${HANDLE}"]`);
    if (ui) return ui;
    ui = document.createElement('div');
    ui.className = 'pc-vg';
    ui.dataset.handle = HANDLE;
    ui.setAttribute('aria-label', 'Choose product option');
    GROUPS.forEach(([title, items]) => {
      const group = document.createElement('div');
      group.className = 'pc-vg__group';
      const heading = document.createElement('span');
      heading.className = 'pc-vg__title';
      heading.textContent = title;
      const options = document.createElement('div');
      options.className = 'pc-vg__options';
      items.forEach(([value, label]) => {
        const variant = variantFor(value);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pc-vg__button';
        button.dataset.value = value;
        button.setAttribute('aria-pressed', 'false');
        const image = document.createElement('img');
        image.className = 'pc-vg__thumb';
        image.alt = '';
        image.loading = 'lazy';
        image.src = thumbnailFor(variant);
        const text = document.createElement('span');
        text.textContent = label;
        button.append(image, text);
        button.addEventListener('click', () => selectVariant(value));
        options.appendChild(button);
      });
      group.append(heading, options);
      ui.appendChild(group);
    });
    const status = document.createElement('p');
    status.className = 'pc-vg__status';
    status.setAttribute('aria-live', 'polite');
    ui.appendChild(status);
    node.parentNode.insertBefore(ui, node);
    return ui;
  }

  function mount() {
    const node = picker();
    if (!node || !productData) return;
    hideNative(node);
    buildUi(node);
    syncVisualState();
  }

  document.addEventListener('click', (event) => {
    if (!productInfo()?.classList.contains('pc-variant-syncing')) return;
    if (event.target.closest('product-form button[name="add"], .shopify-payment-button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', (event) => {
    if (productInfo()?.classList.contains('pc-variant-syncing') && event.target.matches('form[action*="/cart/add"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.closest?.(`variant-selects[data-product-handle="${HANDLE}"]`)) requestAnimationFrame(syncVisualState);
  });
  new MutationObserver(mount).observe(document.body, { childList: true, subtree: true });

  fetch(`/products/${HANDLE}.js`, { headers: { Accept: 'application/json' } })
    .then((response) => {
      if (!response.ok) throw new Error(`product.js returned ${response.status}`);
      return response.json();
    })
    .then((data) => { productData = data; mount(); })
    .catch(() => { /* Preserve the native picker if product data cannot load. */ });
})();
